import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { TransferAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-transfer-slot-v2',
    templateUrl: './transfer-slot-v2.component.html',
    styleUrl: './transfer-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransferSlotComponentV2 implements SheetSlotComponentBase {

	@Input() action!: TransferAction;
	value = null;

	constructor() {
	}
}